function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.3791 24.3704C24.4788 24.3704 23.7463 23.7364 23.7463 22.9572C23.7463 22.1779 24.4788 21.5439 25.3791 21.5439C26.2795 21.5439 27.012 22.1779 27.012 22.9572C27.012 23.367 27.3443 23.6994 27.7541 23.6994C28.164 23.6994 28.4963 23.367 28.4963 22.9572C28.4963 21.5972 27.4829 20.4536 26.1213 20.1432V19.7572C26.1213 19.3474 25.789 19.015 25.3791 19.015C24.9693 19.015 24.637 19.3474 24.637 19.7572V20.1432C23.2753 20.4536 22.262 21.5972 22.262 22.9572C22.262 24.5549 23.6603 25.8548 25.3791 25.8548C26.2795 25.8548 27.012 26.4888 27.012 27.268C27.012 28.0473 26.2795 28.6813 25.3791 28.6813C24.4788 28.6813 23.7463 28.0473 23.7463 27.268C23.7463 26.8582 23.414 26.5259 23.0041 26.5259C22.5943 26.5259 22.262 26.8582 22.262 27.268C22.262 28.6281 23.2753 29.7717 24.637 30.082V30.4027C24.637 30.8125 24.9693 31.1449 25.3791 31.1449C25.789 31.1449 26.1213 30.8125 26.1213 30.4027V30.082C27.4829 29.7717 28.4963 28.6281 28.4963 27.268C28.4963 25.6703 27.098 24.3704 25.3791 24.3704Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.5082 19.9557C32.5387 18.445 31.1728 17.2361 29.5581 16.46C29.1886 16.2823 28.7451 16.4379 28.5676 16.8073C28.39 17.1768 28.5455 17.6202 28.9149 17.7978C31.7287 19.1503 33.5466 22.0403 33.5466 25.1603C33.5466 26.4954 33.2176 27.8194 32.5951 28.9894C32.4026 29.3512 32.5398 29.8006 32.9017 29.9932C33.0127 30.0522 33.1321 30.0803 33.2496 30.0803C33.5152 30.0803 33.772 29.9373 33.9055 29.6866C34.6418 28.3028 35.031 26.7376 35.031 25.1603C35.031 23.3078 34.5044 21.5081 33.5082 19.9557Z",
  fill: "url(#paint1_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.5461 15.5118L26.4961 15.5117C26.0863 15.5117 25.7539 15.844 25.7539 16.2539C25.7539 16.6638 26.0863 16.9961 26.4961 16.9961L26.5391 16.9962C26.5403 16.9962 26.5414 16.9962 26.5426 16.9962C26.9509 16.9962 27.2828 16.6662 27.2848 16.2575C27.2866 15.8476 26.9559 15.5137 26.5461 15.5118Z",
  fill: "url(#paint2_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.8504 32.5228C19.0367 31.1702 17.2187 28.2802 17.2187 25.1603C17.2187 23.8252 17.5478 22.5013 18.1703 21.3313C18.3628 20.9695 18.2256 20.52 17.8637 20.3275C17.502 20.135 17.0523 20.2722 16.8599 20.6341C16.1236 22.0179 15.7344 23.583 15.7344 25.1603C15.7344 27.0128 16.261 28.8124 17.2572 30.3649C18.2267 31.8756 19.5926 33.0845 21.2072 33.8607C21.3109 33.9106 21.4205 33.9341 21.5283 33.9341C21.8047 33.9341 22.07 33.7791 22.1978 33.5134C22.3752 33.1439 22.2198 32.7005 21.8504 32.5228Z",
  fill: "url(#paint3_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.2695 33.3242L24.2265 33.3241C23.8147 33.3234 23.4828 33.6528 23.481 34.0628C23.479 34.4727 23.8099 34.8066 24.2197 34.8085L24.2695 34.8086C24.6793 34.8086 25.0116 34.4763 25.0116 34.0664C25.0116 33.6566 24.6793 33.3242 24.2695 33.3242Z",
  fill: "url(#paint4_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.753 13.0007C28.6626 12.7855 28.552 12.5827 28.4232 12.3945H30.3554C32.2379 12.3945 33.7695 10.8629 33.7695 8.98045C33.7695 7.09797 32.2379 5.5664 30.3554 5.5664H24.412C24.7898 5.01703 25.0117 4.3524 25.0117 3.63671C25.0117 1.75423 23.4801 0.222656 21.5976 0.222656H3.41406C1.53158 0.222656 0 1.75423 0 3.63671C0 5.51919 1.53158 7.05077 3.41406 7.05077H9.35748C8.97964 7.60013 8.7578 8.26476 8.7578 8.98045C8.7578 9.69614 8.97956 10.3608 9.35748 10.9101H7.42186C5.53938 10.9101 4.0078 12.4417 4.0078 14.3242C4.0078 15.4053 4.51353 16.3701 5.30032 16.9961C4.51353 17.622 4.0078 18.5868 4.0078 19.6679C4.0078 20.7491 4.51353 21.7138 5.30032 22.3398C4.51353 22.9658 4.0078 23.9305 4.0078 25.0117C4.0078 26.0928 4.51353 27.0576 5.30032 27.6835C4.51353 28.3095 4.0078 29.2743 4.0078 30.3554C4.0078 32.2379 5.53938 33.7695 7.42186 33.7695H16.1685C18.4727 36.234 21.7507 37.7773 25.3828 37.7773C32.3399 37.7773 38 32.1173 38 25.1602C38 19.3699 34.079 14.4788 28.753 13.0007ZM30.3554 7.05077C31.4195 7.05077 32.2851 7.91645 32.2851 8.98045C32.2851 10.0444 31.4195 10.9101 30.3554 10.9101H25.6054H12.1719C11.1078 10.9101 10.2422 10.0444 10.2422 8.98045C10.2422 7.91645 11.1078 7.05077 12.1719 7.05077H30.3554ZM3.41406 5.5664C2.34998 5.5664 1.48437 4.70071 1.48437 3.63671C1.48437 2.57271 2.34998 1.70703 3.41406 1.70703H21.5976C22.6617 1.70703 23.5273 2.57271 23.5273 3.63671C23.5273 4.70071 22.6617 5.5664 21.5976 5.5664H3.41406ZM7.42186 12.3945H25.6054C25.9044 12.3945 26.1906 12.464 26.4474 12.5884C26.0964 12.5589 25.7415 12.543 25.3828 12.543C21.8986 12.543 18.7399 13.9627 16.4544 16.2539H7.42186C6.35786 16.2539 5.49218 15.3882 5.49218 14.3242C5.49218 13.2602 6.35786 12.3945 7.42186 12.3945ZM7.42186 17.7382H15.1862C14.3437 18.8926 13.6923 20.1945 13.2786 21.5976H7.42186C6.35779 21.5976 5.49218 20.732 5.49218 19.6679C5.49218 18.6039 6.35779 17.7382 7.42186 17.7382ZM7.42186 23.082H12.9378C12.8252 23.7583 12.7657 24.4524 12.7657 25.1602C12.7657 25.7648 12.8094 26.3593 12.892 26.9414H7.42186C6.35779 26.9414 5.49218 26.0757 5.49218 25.0117C5.49218 23.9476 6.35779 23.082 7.42186 23.082ZM7.42186 32.2851C6.35779 32.2851 5.49218 31.4195 5.49218 30.3554C5.49218 29.2913 6.35779 28.4257 7.42186 28.4257H13.195C13.5695 29.822 14.1779 31.1233 14.9758 32.2851H7.42186ZM25.3828 36.293C19.2442 36.293 14.25 31.2988 14.25 25.1602C14.25 19.0216 19.2442 14.0274 25.3828 14.0274C31.5215 14.0274 36.5156 19.0216 36.5156 25.1602C36.5156 31.2988 31.5215 36.293 25.3828 36.293Z",
  fill: "url(#paint5_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 23.5864,
  y1: 19.015,
  x2: 27.9137,
  y2: 19.3512,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 29.8828,
  y1: 16.3865,
  x2: 34.4238,
  y2: 16.7141,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 26.0791,
  y1: 15.5117,
  x2: 27.1227,
  y2: 15.6744,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 17.123,
  y1: 20.2404,
  x2: 21.664,
  y2: 20.568,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 23.8061,
  y1: 33.3241,
  x2: 24.8496,
  y2: 33.4867,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 8.07254,
  y1: 0.222658,
  x2: 34.0011,
  y2: 4.18855,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/money1.99499113.svg";
export { SvgComponent as ReactComponent };